function zoomTransform(group, transform) {
  group.call(this.zoomGen().transform, transform);
  return this;
}

export default zoomTransform;


// WEBPACK FOOTER //
// ./layouts/zoomable/zoomTransform.js